// Embroider/Vite config module. The classic build injected `<prefix>/config/environment`
// into the AMD loader from content-for "config-module"; under Vite that module is not
// synthesized for the app's own namespace, so we provide it explicitly using Embroider's
// official runtime helper. It reads the `<meta name="e-commerce/config/environment">`
// tag that content-for "head" injects into index.html.
import loadConfigFromMeta from '@embroider/config-meta-loader';

export default loadConfigFromMeta('e-commerce');
